import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeIconBlockSkeleton } from './TypeIconBlock';

export interface TypeBlockIconBlocksFields {
    internalName: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Text;
    paragraph?: EntryFieldTypes.Text;
    numberOfColumnsOfBlocks?: EntryFieldTypes.Symbol<'2' | '3'>;
    iconColor?: EntryFieldTypes.Symbol<'black' | 'lime'>;
    iconBlocks?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeIconBlockSkeleton>>;
    backgroundColor?: EntryFieldTypes.Symbol<'ivory' | 'none'>;
}

export type TypeBlockIconBlocksSkeleton = EntrySkeletonType<TypeBlockIconBlocksFields, 'blockIconBlocks'>;
export type TypeBlockIconBlocks<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockIconBlocksSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockIconBlocks<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockIconBlocks<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockIconBlocks';
}
